import React from 'react'

import { useAppSelector } from '@app/app.hook'
import { selectStrings } from '@app/slices/slice.app'

import { IDS } from '@fmt/constants'
import { CareFacilityKeys, CareFacilityValues } from '@fmt/type'
import { FormikProps } from 'formik'

interface ComponentProps {
    readOnly: boolean
    facilityEditFormik: FormikProps<CareFacilityValues>
    handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>
        , fieldName?: CareFacilityKeys) => void
}

const FacilityName = ({ readOnly, facilityEditFormik, handleKeyDown }:ComponentProps) => {
    const strings = useAppSelector(selectStrings)
    const fieldName: CareFacilityKeys = 'facilityName'

    const result = <div className={'form-group'}>
        <div className={'row mt-3 align-items-center'}>
            <div className={'col-3 d-none d-sm-block'}>
                <label htmlFor={IDS.FACILITY.EDIT.FACILITY_NAME} className={'form-label'}>{
                    strings.fmt?.text.facility.add.steps['1'].facility_name
                }</label>
            </div>
            <div className={'col-sm-9 col-12'}>
                <input
                    readOnly={readOnly}
                    type={'text'}
                    name={fieldName}
                    className={[
                        'form-control-sm',
                        readOnly ? 'form-control-plaintext' : 'form-control',
                        facilityEditFormik.errors.facilityName && 'border-danger'
                    ].join(' ')}
                    placeholder={!readOnly
                        ? strings.fmt
                            ?.text.facility.add.steps['1'].facility_name
                        : ''}
                    value={facilityEditFormik.values.facilityName}
                    id={IDS.FACILITY.EDIT.FACILITY_NAME}
                    onBlur={facilityEditFormik.handleBlur}
                    onChange={!readOnly ? facilityEditFormik.handleChange : () => {}}
                    onKeyDown={handleKeyDown}
                    required
                />
                <div className={'form-text error'}>{
                    facilityEditFormik.errors.facilityName
                        ? facilityEditFormik.errors.facilityName
                        : null
                }</div>
            </div>

        </div>

    </div>

    return result
}

export default FacilityName
